import State from "@/helpers/pattern/state";
import { Rep } from "@/models/operativos/rep";
import { modelIsModified } from "@/helpers/vue-mc";
import repAPI from "@/services/operativos/rep";
import { EventBus } from "@/events/event-bus";
import * as events from "@/constants/event-names";
import { clearSwal } from "@/constants/sweet-alerts";
import { scrollToForm } from "@/helpers/form-scroll-to";

/**
 * State Pattern for rep form
 */
export default class RepStates extends State {
  /**
   * General Methods
   */
  base() {
    return {
      clear({ $setState }) {
        $setState("initial");
      }
      , async askForClear({ $data }) {
        try {
          if ((await $data.$swal(clearSwal)).value) this.clear();
        } catch (error) {
          console.error(error);
        }
      }
      , resetModel({ $data }) {
        $data.rep = new Rep();
      }
      , resetValidators({ $data }) {
        $data.$v.$reset();
      }
      , isDisableButtonSubmit({ $data }) {
        return $data.hasErrors($data.$v.rep) || $data.view.action.submit.busy || !modelIsModified($data.rep);
      }
    };
  }

  /**
   * States and their methods
   */
  states() {
    return {
      initial: {
        $constructor: function ({ $data }) {
          // Reset Models and validators
          this.resetModel();
          this.resetValidators();

          // View configuration buttons
          $data.view.elem.button.submit.class.current = $data.view.elem.button.submit.class.save;
          $data.view.elem.button.submit.title.current = $data.view.elem.button.submit.title.save;
        }
        , async submit({ $data }, { code, nombre, apellido, tipo, status, vendor }) {
          try {
            if (!$data.isAllValid($data.$v)) {
              EventBus.$emit(events.SHOW_TOASTER_MESSAGE, "error", "VL0000", $data.$t("errors.validof"));
              scrollToForm($data);
              return false;
            }

            $data.view.action.submit.busy = true;

            const response = await repAPI.save({
              clave: null
              , code
              , nombre
              , apellido
              , tipo: tipo.join()
              , status
              , vendor: (vendor != undefined && vendor != null ? vendor.join() : null)
            });

            $data.view.action.submit.busy = false;
            this.resetModel();
            this.resetValidators();
            $data.$refs.repTable.refreshData();
            return response;
          } catch (error) {
            console.error(error);
            $data.view.action.submit.busy = false;
            return error;
          }
        }
      }
      , editing: {
        $constructor: function ({ $data }, { clave, code, nombre, apellido, tipo, status, vendor }) {
          // View configuration buttons
          $data.view.elem.button.submit.class.current = $data.view.elem.button.submit.class.update;
          $data.view.elem.button.submit.title.current = $data.view.elem.button.submit.title.update;

          $data.rep = new Rep({
            clave
            , code
            , nombre
            , apellido
            , tipo: tipo.split(",")
            , status
            , vendor: (vendor != undefined && vendor != null ? vendor.split(",") : [])
          });

          $data.vendorsRep = [];
          $data.rep.vendor.forEach((elem) => {
            $data.vendorsRep.push(elem * 1);
          });

          this.resetValidators();
          scrollToForm($data);
        }
        , async submit({ $data, $setState }, { clave, code, nombre, apellido, tipo, status, vendor }) {
          try {
            if (!$data.isAllValid($data.$v)) {
              EventBus.$emit(events.SHOW_TOASTER_MESSAGE, "error", "VL0000", $data.$t("errors.validof"));
              scrollToForm($data);
              return false;
            }
            $data.view.action.submit.busy = true;

            const response = await repAPI.update({
              clave
              , code
              , nombre
              , apellido
              , tipo: tipo.join()
              , status
              , vendor: (vendor != undefined && vendor != null ? vendor.join() : null)
            });

            $data.$refs.repTable.refreshData();
            $data.view.action.submit.busy = false;
            $setState("initial");
            return response;
          } catch (error) {
            console.error(error);
            $data.view.action.submit.busy = false;
            return error;
          }
        }
      }
    };
  }
}



// WEBPACK FOOTER //
// ./src/views/operativos/rep/rep-state.js